import DocumentRequestModal from "./DocumentRequestModal";
import { sendNotification } from "./notify";
import React, { useState, useEffect, useMemo } from "react";
import { db } from "../firebase";
import { collection, addDoc, onSnapshot, doc, updateDoc, deleteDoc, query, orderBy, where, getDocs, writeBatch } from "firebase/firestore";
import useClients from "./useClients";

const CATEGORIES = ["Bookkeeping","Tax","CFO Advisory","Cleanup / Catchup","QBO Setup","Payroll Integration","Engagement Letter","Invoicing","Onboarding","Other"];
const PRIORITY_COLORS = {High:["#FAEEDA","#854F0B"],Med:["#E6F1FB","#185FA5"],Low:["#f5f5f0","#888"]};
const STATUS_COLORS = {
  "To Do":["#f5f5f0","#555"],
  "In Progress":["#E6F1FB","#185FA5"],
  "Needs Review":["#FAEEDA","#854F0B"],
  "Completed":["#EAF3DE","#3B6D11"],
};
const FOLDER_REFS = [
  "","Bank Statements","Tax Returns","QBO / Bookkeeping","Payroll",
  "Loan Statements","CFO Reports & Scorecards","Engagement Letters","Corporate Docs","Checks & Receipt Images"
];
// USERS now loaded from Firestore team collection

const S = {
  card:{background:"#fff",border:"0.5px solid #e0dfd8",borderRadius:12,padding:"16px 20px",marginBottom:16},
  btn:{fontSize:12,padding:"5px 13px",borderRadius:8,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  btnPrimary:{fontSize:12,padding:"5px 13px",borderRadius:8,border:"none",background:"#C0111F",color:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  btnSm:{fontSize:11,padding:"3px 9px",borderRadius:6,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer"},
  input:{width:"100%",padding:"6px 9px",fontSize:12,border:"0.5px solid #ccc",borderRadius:8,fontFamily:"sans-serif",background:"#fff",boxSizing:"border-box"},
  badge:(bg,c)=>({display:"inline-block",fontSize:10,padding:"2px 8px",borderRadius:20,background:bg,color:c,fontWeight:500}),
  th:{textAlign:"left",padding:"7px 10px",borderBottom:"0.5px solid #e0dfd8",color:"#888",fontWeight:500,fontSize:12},
  td:{padding:"8px 10px",borderBottom:"0.5px solid #f0efe8",fontSize:12,verticalAlign:"middle"},
};

function TaskModal({task, onClose, onSave, clientNames, isAdmin, currentUserName, teamMembers=["Frank Ficsori"]}){
  const isEdit = !!task.firestoreId;
  const [form, setForm] = useState({
    title:"", client:"", category:"", due:"", priority:"Med",
    assignedTo:"", assignedBy:currentUserName||"Frank Ficsori",
    folderRef:"", notes:"", status:"To Do",
    ...task
  });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.35)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
      <div style={{background:"#fff",borderRadius:16,width:560,maxHeight:"88vh",display:"flex",flexDirection:"column",overflow:"hidden"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 20px",borderBottom:"0.5px solid #e0dfd8",flexShrink:0}}>
          <div style={{fontSize:14,fontWeight:500}}>{isEdit?"Edit Task":"New Task"}</div>
          <button style={{...S.btn,padding:"3px 10px"}} onClick={onClose}>✕</button>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:"16px 20px"}}>
          <div style={{marginBottom:10}}>
            <div style={{fontSize:11,color:"#888",marginBottom:3}}>Task title *</div>
            <input style={S.input} value={form.title} onChange={e=>set("title",e.target.value)} placeholder="e.g. Reconcile March — Client Name"/>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
            <div>
              <div style={{fontSize:11,color:"#888",marginBottom:3}}>Client</div>
              <select style={S.input} value={form.client} onChange={e=>set("client",e.target.value)}>
                <option value="">Select client...</option>
                {clientNames.map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <div style={{fontSize:11,color:"#888",marginBottom:3}}>Category</div>
              <select style={S.input} value={form.category} onChange={e=>set("category",e.target.value)}>
                <option value="">Select category...</option>
                {CATEGORIES.map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <div style={{fontSize:11,color:"#888",marginBottom:3}}>Assign to</div>
              <select style={S.input} value={form.assignedTo} onChange={e=>set("assignedTo",e.target.value)}>
                <option value="">Unassigned</option>
                {teamMembers.map(u=><option key={u}>{u}</option>)}
              </select>
            </div>
            <div>
              <div style={{fontSize:11,color:"#888",marginBottom:3}}>Priority</div>
              <select style={S.input} value={form.priority} onChange={e=>set("priority",e.target.value)}>
                <option>High</option><option>Med</option><option>Low</option>
              </select>
            </div>
            <div>
              <div style={{fontSize:11,color:"#888",marginBottom:3}}>Due date</div>
              <input style={S.input} type="date" value={form.due} onChange={e=>set("due",e.target.value)}/>
            </div>
            <div>
              <div style={{fontSize:11,color:"#888",marginBottom:3}}>Status</div>
              <select style={S.input} value={form.status} onChange={e=>set("status",e.target.value)}>
                {Object.keys(STATUS_COLORS).map(s=><option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <div style={{marginBottom:10}}>
            <div style={{fontSize:11,color:"#888",marginBottom:3}}>Reference folder</div>
            <select style={S.input} value={form.folderRef} onChange={e=>set("folderRef",e.target.value)}>
              {FOLDER_REFS.map(f=><option key={f} value={f}>{f||"No folder reference"}</option>)}
            </select>
            {form.folderRef && <div style={{fontSize:11,color:"#185FA5",marginTop:4}}>📁 Files for this task are in the {form.folderRef} folder in Secure Files</div>}
          </div>
          <div>
            <div style={{fontSize:11,color:"#888",marginBottom:3}}>Notes / instructions</div>
            <textarea style={{...S.input,resize:"vertical",minHeight:72}} value={form.notes} onChange={e=>set("notes",e.target.value)} placeholder="Add instructions, context, or details for this task..."/>
          </div>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",padding:"14px 20px",borderTop:"0.5px solid #e0dfd8",flexShrink:0}}>
          <button style={S.btn} onClick={onClose}>Cancel</button>
          <button style={S.btnPrimary} onClick={()=>{if(!form.title){alert("Task title is required.");return;}onSave(form);}}>
            {isEdit?"Save Changes":"Create Task"}
          </button>
        </div>
      </div>
    </div>
  );
}

function BoardTaskCard({ t, isNew, status, isAdmin, onEdit, onDelete, onStatus, onNavigate, onFolderNav }) {
  const [expanded, setExpanded] = useState(false);

  // Mark notification as read when task is expanded
  const handleExpand = async () => {
    setExpanded(ex=>!ex);
    if(!expanded && t.firestoreId){
      try{
        const { getDocs, query: fq, collection: fc, where: fw, writeBatch: wb, doc: fd } = await import("firebase/firestore");
        const { db: fdb } = await import("../firebase");
        const snap = await getDocs(fq(fc(fdb,"notifications"),
          fw("type","==","task_assigned"),
          fw("read","==",false)
        ));
        const batch = wb(fdb);
        snap.docs
          .filter(d=>d.data().details&&d.data().details.includes(t.title))
          .forEach(d=>batch.update(fd(fdb,"notifications",d.id),{read:true}));
        await batch.commit();
      }catch(e){}
    }
  };
  return (
    <div style={{background:"#fff",border:"0.5px solid "+(isNew?"#C0111F":"#e0dfd8"),borderRadius:10,padding:"12px 14px",marginBottom:8,boxShadow:isNew?"0 0 0 2px #C0111F22":"none",cursor:"pointer"}} onClick={(e)=>{if(!e.target.closest("button")&&!e.target.closest("select")&&!e.target.closest("a"))handleExpand();}}>
      {isNew&&<div style={{fontSize:10,color:"#C0111F",fontWeight:500,marginBottom:4}}>● New</div>}
      <div style={{fontSize:12,fontWeight:500,marginBottom:4,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span>{t.title}</span> <span style={{fontSize:10,color:"#aaa"}}>{expanded?"▲":"▼"}</span>
      </div>
      {t.client&&<div style={{fontSize:11,color:"#888",marginBottom:4}}>{t.client}</div>}
      <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:6}}>
        {t.priority&&<span style={S.badge(...(PRIORITY_COLORS[t.priority]||["#f5f5f0","#888"]))}>{t.priority}</span>}
        {t.category&&<span style={S.badge("#f5f5f0","#555")}>{t.category}</span>}
        {t.hasClientResponse&&<span style={S.badge("#EAF3DE","#3B6D11")}>💬 Response</span>}
      </div>
      {t.assignedTo&&<div style={{fontSize:11,color:"#555",marginBottom:3}}>→ {t.assignedTo}</div>}
      {t.folderRef&&(
        <div style={{fontSize:11,color:"#185FA5",marginBottom:3,cursor:"pointer",textDecoration:"underline"}}
          onClick={()=>onFolderNav?onFolderNav(t.folderRef):onNavigate&&onNavigate("files")}>
          📁 {t.folderRef} →
        </div>
      )}
      {t.due&&<div style={{fontSize:11,color:"#888",marginBottom:6}}>Due {new Date(t.due+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"})}</div>}

      {expanded&&(
        <div style={{borderTop:"0.5px solid #f0efe8",paddingTop:8,marginTop:4}}>
          {t.notes&&(
            <div style={{marginBottom:8}}>
              <div style={{fontSize:10,color:"#888",fontWeight:500,marginBottom:3,textTransform:"uppercase",letterSpacing:"0.05em"}}>Instructions</div>
              <div style={{fontSize:12,color:"#555",lineHeight:1.6,background:"#fafaf8",padding:"8px 10px",borderRadius:6}}>{t.notes}</div>
            </div>
          )}
          {t.clientResponse&&(
            <div style={{marginBottom:8}}>
              <div style={{fontSize:10,color:"#3B6D11",fontWeight:500,marginBottom:3,textTransform:"uppercase",letterSpacing:"0.05em"}}>
                💬 Client Response — {t.clientRespondedAt?new Date(t.clientRespondedAt).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}):""}
              </div>
              <div style={{fontSize:12,background:"#EAF3DE",color:"#1a1a18",padding:"8px 10px",borderRadius:6,borderLeft:"2px solid #3B6D11",lineHeight:1.6}}>{t.clientResponse}</div>
            </div>
          )}
        </div>
      )}

      <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:6}}>
        {Object.keys(STATUS_COLORS).filter(s=>s!==status).map(s=>(
          <button key={s} style={{...S.btnSm,fontSize:10,padding:"2px 7px"}} onClick={()=>onStatus(s)}>→ {s}</button>
        ))}
        {isAdmin&&<button style={{...S.btnSm,fontSize:10,color:"#888"}} onClick={onEdit}>Edit</button>}
        {isAdmin&&<button style={{...S.btnSm,fontSize:10,color:"#A32D2D",borderColor:"#FCEBEB",background:"#FCEBEB"}} onClick={onDelete}>Del</button>}
      </div>
    </div>
  );
}

export default function Tasks({ assignedClients, currentUser, currentUserName, navigate, navigateToFolder, externalTasks }){
  const { clientNames: CLIENT_NAMES } = useClients(assignedClients);
  const isAdmin = !currentUser || currentUser.toLowerCase()==="frank@ficsoriaccounting.com";

  const [teamMembers, setTeamMembers] = useState(["Frank Ficsori"]);

  useEffect(()=>{
    const unsub = onSnapshot(collection(db,"team"), snap=>{
      const names = snap.docs.map(d=>d.data().name).filter(Boolean).sort();
      setTeamMembers(["Frank Ficsori", ...names]);
    });
    return ()=>unsub();
  },[]);

  const [internalTasks, setInternalTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [docRequestModal, setDocRequestModal] = useState(false);
  const [view, setView] = useState("board");
  const [filterClient, setFilterClient] = useState("All Clients");
  const [filterAssignee, setFilterAssignee] = useState("All");
  const [seenTaskIds, setSeenTaskIds] = useState(()=>{
    try{ return new Set(JSON.parse(localStorage.getItem("ficsori_seen_tasks")||"[]")); }catch(e){ return new Set(); }
  });

  useEffect(()=>{
    const q = query(collection(db,"tasks"), orderBy("createdAt","desc"));
    const unsub = onSnapshot(q, snap=>{
      setInternalTasks(snap.docs.map(d=>({...d.data(), firestoreId:d.id})));
      setLoading(false);
    }, err=>{ console.error(err); setLoading(false); });
    return ()=>unsub();
  },[]);

  const tasks = externalTasks || internalTasks;

  const markSeen = (taskIds) => {
    const updated = new Set([...seenTaskIds, ...taskIds]);
    setSeenTaskIds(updated);
    localStorage.setItem("ficsori_seen_tasks", JSON.stringify([...updated]));
  };

  const saveTask = async (form) => {
    console.log("=== SAVETASK CALLED ===", JSON.stringify({assignedTo:form.assignedTo, title:form.title, currentUser, myName, currentUserName}));
    const {firestoreId, ...data} = form;
    data.createdAt = data.createdAt || new Date().toISOString();
    data.updatedAt = new Date().toISOString();
    console.log("saveTask called - assignedTo:", data.assignedTo, "myName:", myName, "currentUserName:", currentUserName);
    try{
      if(firestoreId){ await updateDoc(doc(db,"tasks",firestoreId), data); }
      else{
        await addDoc(collection(db,"tasks"), data);
        // Notify client if task is client-facing (isDocumentRequest or has client)
        if(data.client && (data.isDocumentRequest || data.isClientTask)){
          try{
            const { getDocs, query: fsQuery, where: fsWhere } = await import("firebase/firestore");
            const clientSnap = await getDocs(fsQuery(collection(db,"clients"), fsWhere("name","==",data.client)));
            if(!clientSnap.empty){
              const clientData = clientSnap.docs[0].data();
              if(clientData.email){
                sendNotification("document_request",{
                  recipientEmail: clientData.email,
                  recipientName: clientData.contact||clientData.name,
                  senderName: myName||"Frank Ficsori",
                  clientName: data.client,
                  details: `${data.title}${data.notes?"<br><br>"+data.notes:""}`,
                });
              }
            }
          }catch(e){ console.error("Client task notification failed:", e); }
        }
        // Notify assignee — use email-based lookup to avoid name timing issues
        if(data.assignedTo){
          const isAssignedToFrank = data.assignedTo === "Frank Ficsori";
          const senderIsFrank = currentUser === "frank@ficsoriaccounting.com";
          // Only notify if assignee is different from sender
          const shouldNotify = isAssignedToFrank ? !senderIsFrank : data.assignedTo !== (myName||currentUserName);
          console.log("Task notification check - assignedTo:", data.assignedTo, "currentUser:", currentUser, "shouldNotify:", shouldNotify);
          if(shouldNotify){
            sendNotification("task_assigned",{
              recipientEmail: isAssignedToFrank ? "frank@ficsoriaccounting.com" : "lookup@placeholder.com",
              recipientName: data.assignedTo,
              senderName: senderIsFrank ? "Frank Ficsori" : (myName||currentUserName||"Team Member"),
              clientName: data.client||"",
              details: `Task assigned: ${data.title}${data.client?" ("+data.client+")":""}${data.notes?"<br><br>"+data.notes:""}`,
              portalUrl: "https://portal.ficsoriaccounting.com/#tasks",
            });
          }
        }
      }
      setModal(null);
    }catch(e){ alert("Failed to save task: "+e.message); }
  };

  const deleteTask = async (firestoreId) => {
    if(!window.confirm("Delete this task?")) return;
    try{ await deleteDoc(doc(db,"tasks",firestoreId)); }catch(e){}
  };

  const updateStatus = async (firestoreId, status) => {
    try{
      await updateDoc(doc(db,"tasks",firestoreId),{status,updatedAt:new Date().toISOString()});
      // Auto-clear related task_assigned notifications when task is completed/done
      if(status==="Completed"||status==="Done"){
        const task = tasks.find(t=>t.firestoreId===firestoreId);
        if(task){
          const notifSnap = await getDocs(query(
            collection(db,"notifications"),
            where("type","==","task_assigned"),
            where("read","==",false)
          ));
          const batch = writeBatch(db);
          notifSnap.docs
            .filter(d=>d.data().details&&d.data().details.includes(task.title))
            .forEach(d=>batch.update(d.ref,{read:true}));
          await batch.commit();
        }
      }
    }catch(e){}
  };

  const myName = currentUserName || "Frank Ficsori";

  // Filter tasks
  const filtered = useMemo(()=> tasks.filter(t=>{
    // Always show tasks assigned directly to this user
    if(t.assignedTo === myName) return true;
    // Otherwise filter by assigned clients
    if(assignedClients && t.client && !assignedClients.includes(t.client)) return false;
    if(filterClient!=="All Clients" && t.client!==filterClient) return false;
    if(filterAssignee==="Mine" && t.assignedTo!==currentUserName) return false;
    if(filterAssignee==="Assigned by me" && t.assignedBy!==currentUserName) return false;
    if(filterAssignee==="Unassigned" && t.assignedTo) return false;
    return true;
  }), [tasks, assignedClients, filterClient, filterAssignee, currentUserName]);

  // Unread count — tasks assigned to me that I haven't seen yet
  const unreadTasks = tasks.filter(t=> t.assignedTo===myName && !seenTaskIds.has(t.firestoreId));
  const newClientResponses = isAdmin ? tasks.filter(t=> t.hasClientResponse && !seenTaskIds.has(t.firestoreId+"_resp")) : [];

  const byStatus = (status) => filtered.filter(t=>(t.status||"To Do")===status);

  if(loading) return <div style={{textAlign:"center",padding:"40px 0",color:"#888",fontSize:13}}>Loading tasks...</div>;


  return (
    <div>
      {docRequestModal && <DocumentRequestModal client={{name: filterClient !== 'All Clients' ? filterClient : ''}} onClose={()=>setDocRequestModal(false)} currentUserName={myName} isAdmin={isAdmin}/>}
      {modal && <TaskModal task={modal} onClose={()=>setModal(null)} onSave={saveTask} clientNames={CLIENT_NAMES} isAdmin={isAdmin} currentUserName={myName} teamMembers={teamMembers}/>}

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{fontSize:14,fontWeight:500}}>Tasks & Workflow</div>
          {newClientResponses.length>0 && (
            <div style={{background:"#3B6D11",color:"#fff",fontSize:11,fontWeight:500,padding:"2px 8px",borderRadius:20,cursor:"pointer"}}
              onClick={()=>markSeen(newClientResponses.map(t=>t.firestoreId+"_resp"))}>
              💬 {newClientResponses.length} client response{newClientResponses.length!==1?"s":""}
            </div>
          )}
          {unreadTasks.length>0 && (
            <div style={{background:"#C0111F",color:"#fff",fontSize:11,fontWeight:500,padding:"2px 8px",borderRadius:20,cursor:"pointer"}} onClick={()=>markSeen(unreadTasks.map(t=>t.firestoreId))}>
              {unreadTasks.length} new task{unreadTasks.length!==1?"s":""} assigned to you
            </div>
          )}
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <select style={{...S.input,width:180}} value={filterClient} onChange={e=>setFilterClient(e.target.value)}>
            <option>All Clients</option>
            {CLIENT_NAMES.map(c=><option key={c}>{c}</option>)}
          </select>
          <select style={{...S.input,width:160}} value={filterAssignee} onChange={e=>setFilterAssignee(e.target.value)}>
            <option value="All">All Tasks</option>
            <option value="Mine">Assigned to me</option>
            <option value="Assigned by me">Assigned by me</option>
            <option value="Unassigned">Unassigned</option>
            {teamMembers.map(u=><option key={u} value={u}>{u}</option>)}
          </select>
          <div style={{display:"flex",gap:4}}>
            {[["board","Board"],["list","List"]].map(([v,l])=>(
              <button key={v} onClick={()=>setView(v)} style={{...S.btn,background:view===v?"#1a1a18":"#fff",color:view===v?"#fff":"#555",border:"0.5px solid "+(view===v?"#1a1a18":"#ccc")}}>{l}</button>
            ))}
          </div>
          <button style={{...S.btn,color:"#534AB7",borderColor:"#C5C3F0",background:"#EEEDFE"}} onClick={()=>setDocRequestModal(true)}>📄 Request Documents</button>
          <button style={S.btnPrimary} onClick={()=>setModal({})}>+ New Task</button>
        </div>
      </div>

      {view==="board" && (
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
          {Object.keys(STATUS_COLORS).map(status=>{
            const col = byStatus(status);
            const [bg,c] = STATUS_COLORS[status];
            return (
              <div key={status}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{fontSize:12,fontWeight:500}}>{status}</div>
                  <span style={S.badge(bg,c)}>{col.length}</span>
                </div>
                {col.length===0&&<div style={{fontSize:12,color:"#aaa",textAlign:"center",padding:"20px 8px",border:"0.5px dashed #e0dfd8",borderRadius:8}}>No tasks</div>}
                {col.map(t=>{
                  const isNew = unreadTasks.some(u=>u.firestoreId===t.firestoreId);
                  return (
                    <BoardTaskCard key={t.firestoreId} t={t} isNew={isNew} status={status} isAdmin={isAdmin} onEdit={()=>setModal(t)} onDelete={()=>deleteTask(t.firestoreId)} onStatus={(s)=>updateStatus(t.firestoreId,s)} onNavigate={navigate} onFolderNav={navigateToFolder}/>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}

      {view==="list" && (
        <div style={S.card}>
          {filtered.length===0
            ?<div style={{fontSize:13,color:"#aaa",textAlign:"center",padding:"32px 0"}}>No tasks match your filters.</div>
            :<table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead><tr>
                <th style={S.th}>Task</th>
                <th style={S.th}>Client</th>
                <th style={S.th}>Assigned To</th>
                <th style={S.th}>Priority</th>
                <th style={S.th}>Due</th>
                <th style={S.th}>Folder Ref</th>
                <th style={S.th}>Status</th>
                <th style={S.th}></th>
              </tr></thead>
              <tbody>
                {filtered.map(t=>{
                  const isNew = unreadTasks.some(u=>u.firestoreId===t.firestoreId);
                  return (
                    <tr key={t.firestoreId} style={{background:isNew?"#fff8f8":"transparent"}}>
                      <td style={S.td}>
                        <div style={{fontWeight:500}}>{t.title}{isNew&&<span style={{marginLeft:6,fontSize:10,color:"#C0111F",fontWeight:500}}>● New</span>}{t.hasClientResponse&&<span style={{marginLeft:6,fontSize:10,color:"#3B6D11",fontWeight:500}}>💬 Client responded</span>}</div>
                        {t.notes&&<div style={{fontSize:11,color:"#888",marginTop:2}}>{t.notes.slice(0,60)}{t.notes.length>60?"...":""}</div>}
                        {t.clientResponse&&<div style={{fontSize:11,color:"#3B6D11",marginTop:2,fontStyle:"italic"}}>Response: "{t.clientResponse.slice(0,80)}{t.clientResponse.length>80?"...":""}&quot;</div>}
                      </td>
                      <td style={{...S.td,color:"#888"}}>{t.client||"—"}</td>
                      <td style={S.td}>{t.assignedTo?<span style={S.badge("#E6F1FB","#185FA5")}>{t.assignedTo}</span>:<span style={{color:"#aaa",fontSize:11}}>Unassigned</span>}</td>
                      <td style={S.td}>{t.priority&&<span style={S.badge(...(PRIORITY_COLORS[t.priority]||["#f5f5f0","#888"]))}>{t.priority}</span>}</td>
                      <td style={{...S.td,color:"#888",whiteSpace:"nowrap"}}>{t.due?new Date(t.due+"T12:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}):"—"}</td>
                      <td style={S.td}>{t.folderRef?<span style={{fontSize:11,color:"#185FA5"}}>📁 {t.folderRef}</span>:<span style={{color:"#aaa",fontSize:11}}>—</span>}</td>
                      <td style={S.td}>
                        <select style={{fontSize:11,padding:"2px 6px",borderRadius:6,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer"}}
                          value={t.status||"To Do"} onChange={e=>updateStatus(t.firestoreId,e.target.value)}>
                          {Object.keys(STATUS_COLORS).map(s=><option key={s}>{s}</option>)}
                        </select>
                      </td>
                      <td style={S.td}>
                        <div style={{display:"flex",gap:4}}>
                          {isAdmin&&<button style={S.btnSm} onClick={()=>setModal(t)}>Edit</button>}
                          {isAdmin&&<button style={{...S.btnSm,color:"#A32D2D",borderColor:"#FCEBEB",background:"#FCEBEB"}} onClick={()=>deleteTask(t.firestoreId)}>Del</button>}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          }
        </div>
      )}
    </div>
  );
}
